import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersComponent } from './users.component';
import { ComponentsModule } from 'projects/access-control/src/app/UI/components/component.module';
import { TableUserModule } from 'projects/access-control/src/app/UI/components/table-users/table.users.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ActionsTableModule } from 'projects/access-control/src/app/UI/commons/actions-table/actions-table.module';
import { TooltipModule } from 'primeng/tooltip';
import { LayoutTableModule } from 'projects/access-control/src/app/UI/commons/layout-table/layout-table.module';
import { CommonsModule } from 'projects/access-control/src/app/UI/commons/commons.module';

@NgModule({
	declarations: [UsersComponent],
	exports: [UsersComponent],
	imports: [
		CommonModule,
		NgxDatatableModule,
		ComponentsModule,
		LayoutTableModule,
		CommonsModule,
		ActionsTableModule,
		TableUserModule,
		TooltipModule,
	],
})
export class UsersModule {}
